import { render, staticRenderFns } from "./index-head.vue?vue&type=template&id=038cc334&scoped=true&"
import script from "./index-head.vue?vue&type=script&lang=js&"
export * from "./index-head.vue?vue&type=script&lang=js&"
import style0 from "./index-head.vue?vue&type=style&index=0&id=038cc334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038cc334",
  null
  
)

export default component.exports